<template lang="pug">
  .b2b-login-password-form-canal
    login-password-form-generic(
      :logo='logo'
      :next='next'
      :back='back')
</template>

<script>
import B2bLoginPasswordFormGeneric from '@/components/logingeneric/B2bLoginPasswordFormGeneric'

export default {
  name: 'login-password-form-canal',

  data () {
    return {
      logo: null,
      next: '/CanalSA/new-password-final-form',
      back: '/CanalSA'
    }
  },
  components: {
    'login-password-form-generic': B2bLoginPasswordFormGeneric
  }

}
</script>
<style lang="scss" scoped>
  ::v-deep .ods-input, .ods-input__inner {
    background-color: #93dce742!important;
    color: #93dce742!important;
    border: 1px solid #0084c9;
  }
  ::v-deep .ods-button__custom {
    background-color: #0084c9!important;
  }
  ::v-deep .ods-p-32{
    color: #0084c9!important;
  }
  .login-form {
    padding-top: 1rem;
  }
  .login-form {
    &__canalcau {
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      color: #0084c9;
    }
  }
</style>
